import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "convex/react";

function OfferBar() {
  const offers = useQuery("offers:get") || [];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (offers.length <= 1) return;

    const interval = setInterval(() => {
      // fade out
      setIsVisible(false);

      // after fade out, switch offer and fade in
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % offers.length);
        setIsVisible(true);
      }, 400);
    }, 6000);

    return () => clearInterval(interval);
  }, [offers.length]);

  if (offers.length === 0) return null;

  const offer = offers[currentIndex];

  return (
    <Link to="/blog">
      <div className="absolute top-[138px] left-0 w-full bg-[#ff0336] overflow-hidden whitespace-nowrap py-3 cursor-pointer z-[45]">
        <div className="flex items-center justify-center gap-4">
          <p
            className={`text-white font-bold text-[1.4rem] uppercase tracking-widest text-center transition-all duration-400 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
            }`}
          >
            🔥 {offer.title} — {offer.description}
          </p>
          {offers.length > 1 && (
            <div className="flex gap-2 ml-4">
              {offers.map((_, i) => (
                <span
                  key={i}
                  className={`w-[6px] h-[6px] rounded-full transition-all duration-300 ${
                    i === currentIndex ? "bg-white scale-125" : "bg-[rgba(255,255,255,0.4)]"
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}

export default OfferBar;
